import { ValidatorFn, Validators } from '@angular/forms';
import { KeyValuePair } from '../../../models/base';

export interface EERegistrationInfo {
  RegistrationId: string;
  PersonId: number;
  ClientCode: string;
  UserId: string;
  Email: string;
  Status: EERegistrationStatus;
  CanContinueRegistration: boolean;
}

export interface EERegistrationVerificationOptions {
  HasBirthdate: boolean;
  HasCity: boolean;
  HasDirectDeposit: boolean;
  HasPhone: boolean;
  HasPostalCode: boolean;
  HasSSN: boolean;
  HasState: boolean;
  HasStreetAddress: boolean;
  HasValidEmail: boolean;
}

export interface ValidationRequest {
  FieldToVerify: RegistrationVerificationFields;
  Value: string;
}

export enum RegistrationVerificationFields {
  Email = 1,
  SSN = 2,
  DirectDeposit = 3,
  Birthdate = 4,
  Phone = 5,
  StreetAddress = 6,
  City = 7,
  State = 8,
  PostalCode = 9
}

export enum EERegistrationStatus {
  Unregistered = 0,
  InvitationSent = 1,
  Registered = 2,
  Locked = 3,
  Ineligible = 4,
  Verified = 5
}

export class VerificationQuestion {
  label: string;
  isDate: boolean;
  isPhone: boolean;
  inputMask: string | null;
  placeholder: string | null;
  validators: ValidatorFn | ValidatorFn[];
  field: RegistrationVerificationFields;
  validatorMessages: KeyValuePair[];
  constructor(
    label: string,
    field: RegistrationVerificationFields,
    validators: ValidatorFn[] = [],
    validatorMessages: KeyValuePair[] = [],
    isDate: boolean = false,
    isPhone: boolean = false,
    inputMask: string = null,
    placeholder: string = null
  ) {
    this.label = label;
    this.field = field;
    this.validators = [Validators.required, ...validators];
    this.validatorMessages = [
      new KeyValuePair('required', 'You must provide a response.'),
      ...validatorMessages
    ];
    this.isDate = isDate;
    this.isPhone = isPhone;
    this.inputMask = inputMask;
    this.placeholder = placeholder;
  }
}

export interface ValidationResult {
  Verified: boolean;
}
